<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/platform/education_table'}">教程管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-form-item prop="title"
                      label="教程标题:">
          <el-input v-model="form.title"
                    :maxlength="11"
                    placeholder="不超过11个字"></el-input>
        </el-form-item>
        <el-form-item prop="content"
                      label="教程正文:"
                      v-if="form.type === 1">
          <wang-editor v-model="form.content"
                       :menus="['head','bold','italic','underline','strikeThrough','foreColor','list','justify','quote','table','undo','redo','image']"
                       :colors="['#f3605b', '#333']"
                       :uploadFilePath="uploadFilePath"
                       uploadFileName="file"></wang-editor>
        </el-form-item>
        <el-form-item prop="video_url"
                      label="教程视频:"
                      v-if="form.type === 2">
          <el-upload class="upload-demo"
                     action=""
                     :on-change="onHandleChangeViedeo"
                     :show-file-list="false"
                     :auto-upload="false">
            <el-button size="small"
                       type="primary">点击上传
            </el-button>
          </el-upload>
          <a v-if="form.type === 2 && form.video_url"
             :href="form.video_url"
             target="_blank">
            <el-button type="primary"
                       size="mini">查看详情
            </el-button>
          </a>
        </el-form-item>
        <el-form-item prop="description"
                      label="教程简介:">
          <el-input v-model="form.description"
                    :maxlength="14"
                    placeholder="不超过14个字"></el-input>
        </el-form-item>
        <el-form-item prop="image_url"
                      label="封面:">
          <el-upload class="avatar-uploader"
                     :show-file-list="false"
                     :on-change="onChangeImg"
                     action=""
                     :auto-upload="false"
                     ref="uploadThumb">
            <img v-if="form.image_url"
                 :src="form.image_url+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                 class="avatar">
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="level"
                      label="优先级:">
          <el-input v-model="form.level"
                    placeholder="请输入优先级"
                    type="number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">新建
          </el-button>
          <router-link :to="{ path: '/platform/education_table'}">
            <el-button>取消</el-button>
          </router-link>
        </el-form-item>
      </el-form>

    </layout-panel>

  </div>
</template>

<script>
import { searchRules } from '../platform.rules.js'
import WangEditor from '@components/WangEditorV3Deprecated'

export default {
  components: {WangEditor},
  data () {
    return {
      searchRules,
      selectLoading: false,
      form: {
        id: this.$route.query.id,
        title: null,
        content: null,
        video_url: null,
        description: null,
        image_url: null,
        level: null,
        type: Number(this.$route.query.type),
      },
      uploadFilePath: null,
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.uploadFilePath = window._env_.VUE_APP_ADMIN_HOST + '/helpcenter_upload_file'
    if (this.form.id !== null && this.form.id !== undefined) {
      this.onGetEducation()
    }
  },
  methods: {
    ...Vuex.mapActions(['createEducation', 'editEducation', 'uploadFile', 'getEducation']),

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = {
            title: this.form.title,
            content: this.form.content,
            video_url: this.form.video_url,
            description: this.form.description,
            image_url: this.form.image_url,
            level: this.form.level,
            type: this.$route.query.type,
          }
          if (this.form.id === null || this.form.id === undefined) {
            return request.common('createEducation', data).then((data) => {
              this.$message({
                showClose: true,
                message: '保持成功',
                type: 'success',
              })
              this.$router.push({path: '/platform/education_table'})
            })
          } else {
            data.id = this.form.id
            return request.common('editEducation', data).then((data) => {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
              })
              this.$router.push({path: '/platform/education_table'})
            })
          }
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    onChangeImg (file, filelist) {
      if (file.raw.type !== 'application/x-img' && file.raw.type !== 'image/png' && file.raw.type !== 'image/jpeg') {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.uploadThumb.clearFiles()
        return false
      }

      let isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let width = 688
      let height = 340
      let self = this
      let reader = new FileReader()
      reader.onload = function (e) {
        let data = e.target.result
        let img = new Image()
        img.src = data
        img.onload = function () {
          if (img.width === width && img.height === height) {
            let data = new FormData()
            data.append('file', file.raw)
            return request.common('uploadFile', data).then((res) => {
              self.form.image_url = res.data
            })
          } else {
            self.$message.error('上传图片的宽度为' + img.width + ',长度为' + img.height + ',限制尺寸宽度为' + width + ',长度为' + height + ',请重新选择图片尺寸上传')
          }
        }
      }
      reader.readAsDataURL(file.raw)
    },
    onHandleChangeViedeo (file, filelist) {
      if (file.raw.type !== 'video/mp4') {
        this.$message.error('请上传mp4视频!')
        this.$refs.uploadThumb.clearFiles()
        return false
      }
      let isLt10M = file.raw.size / 1024 / 1024 < 50
      if (!isLt10M) {
        this.$message.error('大小不能超过20MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let data = new FormData()
      data.append('file', file.raw)
      return request.common('uploadFile', data).then((res) => {
        this.form.video_url = res.data
      })
    },
    onGetEducation () {
      return request.page('getEducation', this.form.id).then((data) => {
        filter.setLoop(this.form, data.data)
      })
    },
  },

}
</script>
<style lang="scss"
       scoped>
.avatar-uploader {
  width: 148px;
  height: 148px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformEducationForm.vue